<template>
    <div id="MainCardLayout">
        <HrrBreadcrumb PMname="岗位计划管理" CMname="岗位计划申报汇总(院)" />
        <HrrMainCardLayout>
            <template slot="custom">
                <el-form inline :model="searchform">
                    <el-form-item label="计划：">
                        <el-select v-model="searchform.planId" placeholder="请选择">
                            <el-option v-for="item in planIdData" :key="item.planId" :label="item.planName" :value="item.planId">
                            </el-option>
                        </el-select>
                    </el-form-item>
                     <el-form-item label="所：" v-if="tab!='reportAll'">
                        <el-select v-model="searchform.instituteId" placeholder="请选择" filterable>
                            <el-option label="全部" key="" value=""></el-option>
                            <el-option v-for="item in instituteIdData" :key="item.orgId" :label="item.orgName" :value="item.orgId" v-if="showinstitute(item)">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item >
                        <el-input v-model="searchform.startYear" placeholder="开始年份" v-if="tab=='ReportGraduates'||tab=='ReportGraduatesDetail'" ></el-input>
                    </el-form-item>
                    <el-form-item >
                        <el-input v-model="searchform.endYear" placeholder="结束年份" v-if="tab=='ReportGraduates'||tab=='ReportGraduatesDetail'" ></el-input>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" @click="SubmitForm">查询</el-button>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" @click="onExport">导出</el-button>
                    </el-form-item>
                </el-form>
                <el-tabs v-model="tab" type="card" >
                    <el-tab-pane label="岗位需求总表" name="reportAll">
                        <el-table :data="reportAllData"  ref="reportAllData"
                        height="600"
                        border 
                        stripe 
                        highlight-current-row 
                        style="width: 100%" v-loading="rallloading">
                            <el-table-column prop="orgName" label="单位名称" fixed="left" width="300" >
                            </el-table-column>
                            <el-table-column prop="planNum" label="编制数(职工控制数)" width="110" sortable>
                            </el-table-column>
                            <el-table-column prop="onjobNum" label="现有人数" width="110" sortable >
                            </el-table-column>
                            <el-table-column prop="lackNum" label="空编数" width="110" sortable >
                            </el-table-column>
                            <el-table-column prop="retireNum" label="年末退休人数" width="130" sortable>
                            </el-table-column>
                            <el-table-column label="计划补充人员数量">
                                <el-table-column prop="total" label="小计" width="110" sortable>
                                </el-table-column>
                                <el-table-column prop="gNum" label="接收应届高校毕业生" width="110" sortable>
                                </el-table-column>
                                <el-table-column prop="totalNum" label="京外调干" width="110" sortable>
                                </el-table-column>
                                <el-table-column prop="soldierNum" label="接收安置军转干部" width="110" sortable>
                                </el-table-column>
                                <el-table-column prop="oNum"  label="面向社会公开招聘" width="110" sortable>
                                </el-table-column>
                            </el-table-column>
                            <el-table-column prop="remark" label="备注">
                            </el-table-column>
                        </el-table>
                    </el-tab-pane>
                    <el-tab-pane label="高校毕业生总表" name="graduatesAll">
                        <el-table :data="graduatesAllData" ref="graduatesAllData"
                        height="600"
                        border 
                        stripe 
                        highlight-current-row 
                        style="width: 100%" v-loading="gallloading">
                            <el-table-column prop="instituteName" label="单位" width="180" fixed="left" sortable>
                            </el-table-column>
                            <el-table-column prop="orgName" label="部门" width="150" fixed="left" sortable>
                            </el-table-column>
                            <el-table-column prop="postTitle" label="岗位" width="150" fixed="left">
                            </el-table-column>
                            <el-table-column prop="major" label="专业" width="220">
                            </el-table-column>
                            <el-table-column label="京内生源" width="180">
                                <el-table-column prop="inBj_ug" label="本科生"></el-table-column>
                                <el-table-column prop="inBj_master" label="硕士生"></el-table-column>
                                <el-table-column prop="inBj_doctor" label="博士生"></el-table-column>
                                <el-table-column prop="inBj_total" label="小计" >
                                </el-table-column>
                            </el-table-column>
                            <el-table-column label="京外生源" width="180">
                                <el-table-column prop="outBj_ug" label="本科生"></el-table-column>
                                <el-table-column prop="outBj_master" label="硕士生"></el-table-column>
                                <el-table-column prop="outBj_doctor" label="博士生"></el-table-column>
                                <el-table-column prop="outBj_total" label="小计"></el-table-column>
                            </el-table-column>
                            <el-table-column label="不限" width="180" >
                                <el-table-column prop="umlimited_ug" label="本科生"></el-table-column>
                                <el-table-column prop="umlimited_master" label="硕士生"></el-table-column>
                                <el-table-column prop="umlimited_doctor" label="博士生"></el-table-column>
                                <el-table-column prop="umlimited_total" label="小计"></el-table-column>
                            </el-table-column>
                        </el-table>
                    </el-tab-pane>
                    <el-tab-pane label="高校毕业生(京内)" name="graduatesin">
                        <el-table :data="graduatesinData" ref="graduatesinData"
                        border 
                        stripe 
                        highlight-current-row 
                        style="width: 100%" v-loading="giloading" >
                            <el-table-column prop="instituteName" label="单位" width="180" fixed="left" >
                            </el-table-column>
                            <el-table-column prop="orgName" label="部门" width="150" fixed="left" sortable>
                            </el-table-column>
                            <el-table-column prop="postTitle" label="岗位名称" width="150" fixed="left">
                            </el-table-column>
                            <el-table-column prop="postInfo" label="岗位简介" width="180">
                            </el-table-column>
                            <el-table-column prop="needNum" label="招聘人数" width="50">
                            </el-table-column>
                            <el-table-column prop="major" label="专业" width="180">
                            </el-table-column>
                            <el-table-column prop="educationTypeName" label="学历" width="80" sortable>
                            </el-table-column>
                            <el-table-column prop="diplomaTypeName" label="学位" width="80" sortable>
                            </el-table-column>
                            <el-table-column prop="politicalType" label="政治面貌" width="100">
                            </el-table-column>
                            <el-table-column prop="gWrittenProportion" label="计划录用人数与笔试人选的确定比例" width="100">
                            </el-table-column>
                            <el-table-column prop="gInterviewProportion" label="计划录用人数与面试人选的确定比例" width="100">
                            </el-table-column>
                            <el-table-column prop="gIsProfessional" label="是否组织专业考试" width="110" sortable>
                                <template slot-scope="scope">
                                    {{scope.row.gIsProfessional==true?"是":"否"}}
                                </template>
                            </el-table-column>
                            <el-table-column prop="gReviewType" label="考察方式" width="110" sortable>
                            </el-table-column>
                            <el-table-column prop="other" label="其他条件" width="180">
                            </el-table-column>
                            <el-table-column prop="gSourceType" label="生源要求" width="110" sortable>
                            </el-table-column>
                            <el-table-column prop="remark" label="备注" width="180">
                            </el-table-column>
                            <el-table-column label="操作" width="140" fixed="right">
                                <template slot-scope="scope">
                                    <el-button type="text"
                                    @click.stop="changeStatus(scope.row.postId,-10,'g')"
                                    size="small" class="text-danger">不通过</el-button>
                                    <el-button type="text"
                                    @click.stop="changeStatus(scope.row.postId,10,'g')"
                                    size="small" class="text-info">调整</el-button>
                                </template>
                            </el-table-column>
                        </el-table></br>
                        <el-pagination
                        background
                        @size-change="gihandleSizeChange"
                        @current-change="gihandleCurrentChange"
                        :current-page="giform.pageNum"
                        :page-sizes="[5, 10, 15]"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="giform.total">
                        </el-pagination>
                    </el-tab-pane>
                    <el-tab-pane label="高校毕业生(京外)" name="graduatesout">
                        <el-table :data="graduatesoutData" ref="graduatesoutData"
                        border
                        stripe
                        highlight-current-row
                        v-loading="goloading"
                        style="width: 100%" >
                            <el-table-column prop="instituteName" label="单位" width="180" fixed="left" >
                            </el-table-column>
                            <el-table-column prop="orgName" label="部门" width="150" fixed="left" sortable>
                            </el-table-column>
                            <el-table-column prop="postTitle" label="岗位名称" width="150" fixed="left">
                            </el-table-column>
                            <el-table-column prop="postInfo" label="岗位简介" width="180">
                            </el-table-column>
                            <el-table-column prop="needNum" label="招聘人数" width="50">
                            </el-table-column>
                            <el-table-column prop="major" label="专业" width="180">
                            </el-table-column>
                            <el-table-column prop="educationTypeName" label="学历" width="80" sortable>
                            </el-table-column>
                            <el-table-column prop="diplomaTypeName" label="学位" width="80" sortable>
                            </el-table-column>
                            <el-table-column prop="politicalType" label="政治面貌" width="100">
                            </el-table-column>
                            <el-table-column prop="gWrittenProportion" label="计划录用人数与笔试人选的确定比例" width="100">
                            </el-table-column>
                            <el-table-column prop="gInterviewProportion" label="计划录用人数与面试人选的确定比例" width="100">
                            </el-table-column>
                            <el-table-column prop="gIsProfessional" label="是否组织专业考试" width="100" sortable>
                                <template slot-scope="scope">
                                    {{scope.row.gIsProfessional==true?"是":"否"}}
                                </template>
                            </el-table-column>
                            <el-table-column prop="gReviewType" label="考察方式" width="110" sortable>
                            </el-table-column>
                            <el-table-column prop="other" label="其他条件" width="180">
                            </el-table-column>
                            <el-table-column prop="gSourceType" label="生源要求" width="110" sortable>
                            </el-table-column>
                            <el-table-column prop="remark" label="备注" width="180">
                            </el-table-column>
                            <el-table-column label="操作" width="140" fixed="right">
                                <template slot-scope="scope">
                                    <el-button type="text"
                                    @click.stop="changeStatus(scope.row.postId,-10,'g')"
                                    size="small" class="text-danger">不通过</el-button>
                                    <el-button type="text"
                                    @click.stop="changeStatus(scope.row.postId,10,'g')"
                                    size="small" class="text-info">调整</el-button>
                                </template>
                            </el-table-column>
                        </el-table>
                         <br />
                        <el-pagination
                        background
                        @size-change="gohandleSizeChange"
                        @current-change="gohandleCurrentChange"
                        :current-page="goform.pageNum"
                        :page-sizes="[5, 10, 15]"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="goform.total">
                        </el-pagination>
                    </el-tab-pane>
                    <el-tab-pane label="京外调干" name="inbj">
                        <el-table :data="inbjData" ref="inbjData"  
                        height="600"
                        border 
                        stripe 
                        style="width: 100%" v-loading="iloading">
                            <el-table-column prop="orgName" label="单位" width="180" fixed="left">
                            </el-table-column>
                            <el-table-column label="拟京外选调人员数量">
                                <el-table-column prop="totalNum" label="总数" width="80" sortable></el-table-column>
                                <el-table-column prop="greenNum" label="其中符合绿色通道条件人员" width="100" sortable></el-table-column>
                            </el-table-column>
                            <el-table-column prop="major" label="拟补充人员专业情况">
                                <el-table-column prop="major1" label="机械" width="80"></el-table-column>
                                <el-table-column prop="major2" label="电机、电器、电子" width="80"></el-table-column>
                                <el-table-column prop="major3" label="动力" width="80"></el-table-column>
                                <el-table-column prop="major4" label="化工" width="80"></el-table-column>
                                <el-table-column prop="major5" label="土木建筑" width="80"></el-table-column>
                                <el-table-column prop="major6" label="矿业冶金" width="80"></el-table-column>
                                <el-table-column prop="major7" label="轻工纺织粮食" width="80"></el-table-column>
                                <el-table-column prop="major8" label="地质水文测绘" width="80"></el-table-column>
                                <el-table-column prop="major9" label="运输通讯" width="80"></el-table-column>
                                <el-table-column prop="major10" label="管理" width="80"></el-table-column>
                                <el-table-column prop="major11" label="理科" width="80"></el-table-column>
                                <el-table-column prop="major12" label="农业" width="80"></el-table-column>
                                <el-table-column prop="major13" label="林业" width="80"></el-table-column>
                                <el-table-column prop="major14" label="医药" width="80"></el-table-column>
                                <el-table-column prop="major15" label="文史" width="80"></el-table-column>
                                <el-table-column prop="major16" label="外文" width="80"></el-table-column>
                                <el-table-column prop="major17" label="财经" width="80"></el-table-column>
                                <el-table-column prop="major18" label="政法" width="80"></el-table-column>
                                <el-table-column prop="major19" label="体育" width="80"></el-table-column>
                                <el-table-column prop="major20" label="文艺" width="80"></el-table-column>
                            </el-table-column>
                        </el-table>
                    </el-tab-pane>
                    <el-tab-pane label="军转安置" name="soldier">
                        <el-table :data="soldierData" ref="soldierData" 
                        height="600"
                        border 
                        stripe 
                        highlight-current-row 
                        style="width: 100%" v-loading="sloading">
                            <el-table-column prop="inistituteName" label="单位" width="160" fixed="left">
                            </el-table-column>
                            <el-table-column prop="orgName" label="部门" width="120" fixed="left" sortable>
                            </el-table-column>
                            <el-table-column prop="post" label="岗位名称" width="180" fixed="left">
                            </el-table-column>
                            <el-table-column prop="postDesc" label="岗位简介" width="240">
                            </el-table-column>
                            <el-table-column prop="major" label="专业" width="220">
                            </el-table-column>
                            <el-table-column prop="educationType" label="学历" width="80" sortable>
                            </el-table-column>
                            <el-table-column prop="diplomaType" label="学位" width="80" sortable>
                            </el-table-column>
                            <el-table-column prop="politicalType" label="政治面貌" width="110" sortable>
                            </el-table-column>
                            <el-table-column prop="other" label="其他条件" width="230">
                            </el-table-column>
                            <el-table-column prop="remark" label="备注" width="230">
                            </el-table-column>
                        </el-table>
                    </el-tab-pane>
                    <el-tab-pane label="社会招聘岗位(京内)" name="openin">
                        <el-table :data="openinData" ref="openinData"
                         border
                         stripe
                         style="width: 100%" v-loading="oiloading" >
                            <el-table-column prop="instituteName" label="单位" width="160" fixed="left">
                            </el-table-column>
                            <el-table-column prop="orgName" label="部门" width="180" fixed="left" sortable>
                            </el-table-column>
                            <el-table-column prop="postTitle" label="岗位名称" width="160" fixed="left">
                            </el-table-column>
                            <el-table-column prop="postInfo" label="岗位简介" width="220">
                            </el-table-column>
                            <el-table-column prop="needNum" label="招聘人数" width="60">
                            </el-table-column>
                            <el-table-column prop="major" label="专业" width="220">
                            </el-table-column>
                            <el-table-column prop="educationTypeName" label="学历" width="100" sortable>
                            </el-table-column>
                            <el-table-column prop="diplomaTypeName" label="学位" width="100" sortable >
                            </el-table-column>
                            <el-table-column prop="oTitleType" label="职称" width="100" sortable>
                            </el-table-column>
                            <el-table-column prop="oAgeTypeName" label="年龄" width="100" sortable>
                            </el-table-column>
                            <el-table-column prop="politicalType" label="政治面貌" width="110" sortable>
                            </el-table-column>
                            <el-table-column prop="other" label="其他条件" width="180">
                            </el-table-column>
                            <el-table-column prop="oFromType" label="招聘形式" width="120">
                            </el-table-column>
                            <el-table-column prop="oTimeDesc" label="招聘时间" width="180">
                            </el-table-column>
                            <el-table-column prop="remark" label="备注" width="220">
                            </el-table-column>
                            <el-table-column prop="status" label="操作" width="140" fixed="right" >
                                <template slot-scope="scope">
                                    <el-button type="text"
                                    @click.stop="changeStatus(scope.row.postId,-10,'o')"
                                    size="small" class="text-danger">不通过</el-button>
                                    <el-button type="text"
                                    @click.stop="changeStatus(scope.row.postId,10,'o')"
                                    size="small" class="text-info">调整</el-button>
                                </template>
                            </el-table-column>
                        </el-table></br></br>
                        <el-pagination
                        background
                        @size-change="oihandleSizeChange"
                        @current-change="oihandleCurrentChange"
                        :current-page="oiform.pageNum"
                        :page-sizes="[5, 10, 15]"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="oiform.total">
                        </el-pagination>
                    </el-tab-pane>
                    <el-tab-pane label="社会招聘岗位(京外)" name="openout">
                       <el-table :data="openOutData" ref="openOutData"
                        border
                        stripe
                        highlight-current-row
                        v-loading="ooloading"
                        style="width: 100%" >
                            <el-table-column prop="instituteName" label="单位" width="180" fixed="left" >
                            </el-table-column>
                            <el-table-column prop="orgName" label="部门" width="180" fixed="left" sortable>
                            </el-table-column>
                            <el-table-column prop="postTitle" label="岗位名称" fixed="left" width="180" >
                            </el-table-column>
                            <el-table-column prop="postInfo" label="岗位简介" width="220">
                            </el-table-column>
                            <el-table-column prop="needNum" label="招聘人数" width="60">
                            </el-table-column>
                            <el-table-column prop="oRangeType" label="招聘范围" width="120">
                            </el-table-column>
                            <el-table-column prop="major" label="专业" width="220">
                            </el-table-column>
                            <el-table-column prop="educationTypeName" label="学历" width="80" sortable>
                            </el-table-column>
                            <el-table-column prop="diplomaTypeName" label="学位" width="80" sortable>
                            </el-table-column>
                            <el-table-column prop="oTitleTypeName" label="职称" width="100" sortable>
                            </el-table-column>
                            <el-table-column prop="oAgeTypeName" label="年龄" width="100" sortable>
                            </el-table-column>
                            <el-table-column prop="politicalType" label="政治面貌" width="110" sortable>
                            </el-table-column>
                            <el-table-column prop="other" label="其他条件" width="180">
                            </el-table-column>
                            <el-table-column prop="oFromType" label="招聘形式" width="120">
                            </el-table-column>
                            <el-table-column prop="oTimeDesc" label="招聘时间" width="180">
                            </el-table-column>
                            <el-table-column prop="other" label="其他条件" width="220">
                            </el-table-column>
                            <el-table-column prop="remark" label="备注" width="220">
                            </el-table-column>
                            <el-table-column prop="status" label="操作" width="140" fixed="right">
                                <template slot-scope="scope">
                                    <el-button type="text"
                                    @click.stop="changeStatus(scope.row.postId,-10,'o')"
                                    size="small" class="text-danger">不通过</el-button>
                                    <el-button type="text"
                                    @click.stop="changeStatus(scope.row.postId,10,'o')"
                                    size="small" class="text-info">调整</el-button>
                                </template>
                            </el-table-column>
                        </el-table>
                        <br />
                        <el-pagination
                        background
                        @size-change="oohandleSizeChange"
                        @current-change="oohandleCurrentChange"
                        :current-page="ooform.pageNum"
                        :page-sizes="[5, 10, 15]"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="ooform.total">
                        </el-pagination>
                    </el-tab-pane>
                    <el-tab-pane label="毕业生接收情况统计表" name="ReportGraduates">
                        <el-table :data="ReportGraduatesData"
                        height=600
                        border 
                        stripe 
                        highlight-current-row 
                        style="width: 100%" v-loading="rloading" >
                            <el-table-column prop="orgName" label="单位" width="180">
                            </el-table-column>
                            <el-table-column prop="year" label="年份" width="80" sortable>
                            </el-table-column>
                            <el-table-column prop="settleNum" label="实际接收落户人数" width="120" sortable>
                            </el-table-column>
                            <el-table-column prop="onjobNum" label="截止目前在岗人数" width="120" sortable>
                            </el-table-column>
                            <el-table-column prop="retentionRate" label="留存率" width="120" sortable>
                            </el-table-column>
                            <el-table-column label="制度建设情况">
                                <el-table-column prop="isCondition1" label="未制定毕业生招聘接收工作标准和规范">
                                    <template slot-scope="scope">
                                        {{scope.row.isCondition1=="0"?"否":"是"}}
                                    </template>
                                </el-table-column>
                                <el-table-column prop="isCondition2" label="已建立本单位毕业生招聘接收工作标准和规范">
                                    <template slot-scope="scope">
                                        {{scope.row.isCondition2=="0"?"否":"是"}}
                                    </template>
                                </el-table-column>
                                <el-table-column prop="isCondition3" label="执行上级主管部门统一招聘接收工作标准和规范">
                                    <template slot-scope="scope">
                                        {{scope.row.isCondition3=="0"?"否":"是"}}
                                    </template>
                                </el-table-column>
                            </el-table-column>
                            <el-table-column label="毕业招聘接收方式">
                                <el-table-column prop="isWay1" label="面向社会公开招聘" width="100">
                                    <template slot-scope="scope">
                                        {{scope.row.isWay1=="0"?"否":"是"}}
                                    </template>
                                </el-table-column>
                                <el-table-column prop="isWay2" label="校园招聘" width="100">
                                    <template slot-scope="scope">
                                        {{scope.row.isWay2=="0"?"否":"是"}}
                                    </template>
                                </el-table-column>
                                <el-table-column prop="isWay3" label="内部推荐" width="100">
                                    <template slot-scope="scope">
                                        {{scope.row.isWay3=="0"?"否":"是"}}
                                    </template>
                                </el-table-column>
                                <el-table-column prop="isWay4" label="其他（请注明）" width="180">
                                    <template slot-scope="scope">
                                        {{scope.row.isWay4=="0"?"否":"是"}}
                                    </template>
                                </el-table-column>
                            </el-table-column>
                        </el-table>
                    </el-tab-pane>
                    <el-tab-pane label="毕业生接收情况明细表" name="ReportGraduatesDetail">
                        <el-table :data="ReportGraduatesDetailData" 
                        border 
                        stripe 
                        highlight-current-row 
                        style="width: 100%" v-loading="rdloading" >
                            <el-table-column type="index" label="序号" width="60" fixed="left">
                            </el-table-column>
                            <el-table-column prop="year" label="接收年份" width="110" sortable fixed="left">
                            </el-table-column>
                            <el-table-column prop="companyName" label="单位名称" width="180" fixed="left">
                            </el-table-column>
                            <el-table-column prop="departmentName" label="部门名称" width="200" sortable>
                            </el-table-column>
                            <el-table-column prop="post" label="工作岗位(职位)" width="200" sortable>
                            </el-table-column>
                            <el-table-column prop="userName" label="姓名" width="100" >
                            </el-table-column>
                            <el-table-column prop="major" label="专业" width="180">
                            </el-table-column>
                            <el-table-column prop="isMain" label="是否主业">
                                <template slot-scope="scope">
                                    {{scope.row.isMain=="0"?"否":"是"}}
                                </template>
                            </el-table-column>
                            <el-table-column prop="isOnjob" label="是否在岗">
                                <template slot-scope="scope">
                                    {{scope.row.isOnjob=="0"?"否":"是"}}
                                </template>
                            </el-table-column>
                            <el-table-column prop="remark" label="备注">
                            </el-table-column>
                        </el-table>
                        <br />
                        <el-pagination
                        background
                        @size-change="rdhandleSizeChange"
                        @current-change="rdhandleCurrentChange"
                        :current-page="rdform.pageNum"
                        :page-sizes="[5, 10, 15]"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="rdform.total">
                        </el-pagination>
                    </el-tab-pane>
                </el-tabs>
            </template>
        </HrrMainCardLayout>
    </div>
</template>
<script>
    export default {
        name: 'plan_reportyuan',
        data() {
            return {
                tab: 'reportAll',
                searchform: {
                    planId: "",
                    instituteId:""
                },
                oiform:{
                    pageNum:1,
                    pageSize:10,
                    total:0
                },
                giform:{
                    pageNum:1,
                    pageSize:10,
                    total:0
                },
                ooform:{
                    pageNum:1,
                    pageSize:10,
                    total:0
                },
                goform:{
                    pageNum:1,
                    pageSize:10,
                    total:0
                },
                rdform:{
                    pageNum:1,
                    pageSize:10,
                    total:0
                },
                totalNumber: "",
                planIdData:[],
                instituteIdData:[],
                rallloading: true,
                gallloading: true,
                giloading: true,
                goloading: true,
                oiloading: true,
                ooloading: true,
                iloading: true,
                sloading: true,
                rloading: true,
                rdloading: true,
                reportAllData: [],
                graduatesAllData: [],
                graduatesinData: [],
                graduatesoutData: [],
                inbjData: [],
                soldierData: [],
                openinData: [],
                openOutData: [],
                ReportGraduatesData: [],
                ReportGraduatesDetailData: []
            }
        },
        methods: {
            onExport() {
                var ExportURL="";
                if(this.tab=="reportAll"){
                    ExportURL=this.$api.plan.export.yuanall;
                }
                if(this.tab=="graduatesAll"){
                    ExportURL=this.$api.plan.export.yuanGall;
                }
                if(this.tab=="openout"){
                    ExportURL=this.$api.plan.export.yuanOout;
                }
                if(this.tab=="openin"){
                    ExportURL=this.$api.plan.export.yuanOin;
                }
                if(this.tab=="graduatesout"){
                    ExportURL=this.$api.plan.export.yuanGout;
                }
                if(this.tab=="graduatesin"){
                    ExportURL=this.$api.plan.export.yuanGin;
                }
                if(this.tab=="soldier"){
                    ExportURL=this.$api.plan.export.yuanSoldier;
                }
                if(this.tab=="inbj"){
                    ExportURL=this.$api.plan.export.yuanInbj;
                }
                if(this.tab=="ReportGraduatesDetail"){
                    ExportURL=this.$api.plan.export.yuanreportGDetail;
                }
                if(this.tab=="ReportGraduates"){
                    ExportURL=this.$api.plan.export.yuanreportG;
                }
                ExportURL=this.$hrraxios.defaults.baseURL+ExportURL;
                var params=this.$Qs.stringify(this.searchform,{indices: false});
                window.open(ExportURL+"?"+params)
            },
            showinstitute(item){
                if(this.tab.indexOf("in")>-1 ||this.tab=="inbj"|| this.tab=="soldier"){
                    if(item.orgType=="1"){
                        return true;
                    }else{
                        return false;
                    }
                }
                if(this.tab.indexOf("out")>-1){
                    if(item.orgType=="2"){
                        return true;
                    }else{
                        return false;
                    }
                }
                return true;
            },
            SubmitForm() {
                if(this.tab=="reportAll"){
                    this.initreportAllData();
                }
                if(this.tab=="graduatesAll"){
                    this.initgraduatesAllData();
                }
                if(this.tab=="openout"){
                    this.initOpenOutData();
                }
                if(this.tab=="openin"){
                    this.initOpenInData();
                }
                if(this.tab=="graduatesout"){
                    this.initgraduatesOutData();
                }
                if(this.tab=="graduatesin"){
                    this.initgraduatesInData();
                }
                if(this.tab=="soldier"){
                    this.initsoldierData();
                }
                if(this.tab=="inbj"){
                    this.initinbjData();
                }
                if(this.tab=="ReportGraduatesDetail"){
                    this.initReportGraduatesDetailData();
                }
                if(this.tab=="ReportGraduates"){
                    this.initReportGraduatesData();
                }
            },
            oihandleSizeChange(val) {
                this.oiform.pageSize=val;
                this.initOpenInData();
            },
            oihandleCurrentChange(val) {
                this.oiform.pageNum=val;
                this.initOpenInData();
            },
            gihandleSizeChange(val) {
                this.giform.pageSize=val;
                this.initgraduatesInData();
            },
            gihandleCurrentChange(val) {
                this.giform.pageNum=val;
                this.initgraduatesInData();
            },
            oohandleSizeChange(val) {
                this.ooform.pageSize=val;
                this.initOpenOutData();
            },
            oohandleCurrentChange(val) {
                this.ooform.pageNum=val;
                this.initOpenOutData();
            },
            gohandleSizeChange(val) {
                this.goform.pageSize=val;
                this.initgraduatesOutData();
            },
            gohandleCurrentChange(val) {
                this.goform.pageNum=val;
                this.initgraduatesOutData();
            },
            rdhandleSizeChange(val) {
                this.rdform.pageSize=val;
                this.initReportGraduatesDetailData();
            },
            rdhandleCurrentChange(val) {
                this.rdform.pageNum=val;
                this.initReportGraduatesDetailData();
            },
            //人员计划申报总表
            initreportAllData() {
                var Vuethis = this;
                this.rallloading = true;
                this.$hrraxios.get(this.$api.plan.reportYuanTotal, {params:this.searchform})
                .then(function(response) {
                    Vuethis.rallloading = false;
                    var data = response.data;
                    if (data.success == true) {
                        Vuethis.reportAllData = data.data;
                    } else {
                        Vuethis.$message.error(data.prompt);
                    }
                })
                .catch(function(error) {
                    Vuethis.rallloading = false;
                    console.log(error);
                });
            },
            //高校毕业生总表
            initgraduatesAllData() {
                var Vuethis = this;
                this.gallloading = true;
                this.$hrraxios.get(this.$api.plan.reportYuanGSum, {params:this.searchform})
                .then(function(response) {
                    Vuethis.gallloading = false;
                    var data = response.data;
                    if (data.success == true) {
                        Vuethis.graduatesAllData = data.data;
                        Vuethis.graduatesAllData.forEach((e)=>{
                            e.inBj_total=0;
                            e.inBj_total+=(e.inBj_ug!=null)?e.inBj_ug:0;
                            e.inBj_total+=(e.inBj_master!=null)?e.inBj_master:0;
                            e.inBj_total+=(e.inBj_doctor!=null)?e.inBj_doctor:0;
                            e.inBj_total=(e.inBj_total==0)?null:e.inBj_total;
                            e.outBj_total=0;
                            e.outBj_total+=(e.outBj_ug!=null)?e.outBj_ug:0;
                            e.outBj_total+=(e.outBj_master!=null)?e.outBj_master:0;
                            e.outBj_total+=(e.outBj_doctor!=null)?e.outBj_doctor:0;
                            e.outBj_total=(e.outBj_total==0)?null:e.outBj_total;
                            e.umlimited_total=0;
                            e.umlimited_total+=(e.umlimited_ug!=null)?e.umlimited_ug:0;
                            e.umlimited_total+=(e.umlimited_master!=null)?e.umlimited_master:0;
                            e.umlimited_total+=(e.umlimited_doctor!=null)?e.umlimited_doctor:0;
                            e.umlimited_total=(e.umlimited_total==0)?null:e.umlimited_total;
                        });

                    } else {
                        Vuethis.$message.error(data.prompt);
                    }
                })
                .catch(function(error) {
                    Vuethis.gallloading = false;
                    console.log(error);
                });
            },
            //京外社会招聘
            initOpenOutData(){
                var Vuethis=this;
                this.ooloading=true;
                this.searchform.pageNum=this.ooform.pageNum;
                this.searchform.pageSize=this.ooform.pageSize;
                this.$hrraxios.get(this.$api.plan.reportYuanOutbjPub,{params:this.searchform})
                .then(function (response) {
                    Vuethis.ooloading=false;
                    var data=response.data;
                    if(data.success==true)
                    {
                        Vuethis.openOutData=data.data.list;
                        Vuethis.ooform.total=data.data.total;
                    }else{
                        Vuethis.$message.error(data.prompt);
                    }
                })
                .catch(function (error) {
                    Vuethis.ooloading=false;
                    console.log(error);
                });
            },
            //京内社会招聘
            initOpenInData() {
                var Vuethis=this;
                this.oiloading=true;
                this.searchform.pageNum=this.oiform.pageNum;
                this.searchform.pageSize=this.oiform.pageSize;
                this.$hrraxios.get(this.$api.plan.reportYuanInbjPub,{params:this.searchform})
                .then(function (response) {
                    Vuethis.oiloading=false;
                    var data=response.data;
                    if(data.success==true)
                    {
                        Vuethis.openinData=data.data.list;
                        Vuethis.oiform.total=data.data.total;
                    }else{
                        Vuethis.$message.error(data.prompt);
                    }
                })
                .catch(function (error) {
                    Vuethis.oiloading=false;
                    console.log(error);
                });
            },
            //京外高校毕业生
            initgraduatesOutData(){
                var Vuethis=this;
                this.goloading=true;
                this.searchform.pageNum=this.goform.pageNum;
                this.searchform.pageSize=this.goform.pageSize;
                this.$hrraxios.get(this.$api.plan.reportYuanOutbj,{params:this.searchform})
                .then(function (response) {
                    Vuethis.goloading=false;
                    var data=response.data;
                    if(data.success==true)
                    {
                        Vuethis.graduatesoutData=data.data.list;
                        Vuethis.goform.total=data.data.total;
                    }else{
                        Vuethis.$message.error(data.prompt);
                    }
                })
                .catch(function (error) {
                    Vuethis.goloading=false;
                    console.log(error);
                });
            },
            //京内高校毕业生
            initgraduatesInData() {
                var Vuethis=this;
                this.giloading=true;
                this.searchform.pageNum=this.giform.pageNum;
                this.searchform.pageSize=this.giform.pageSize;
                this.$hrraxios.get(this.$api.plan.reportYuanInbj,{params:this.searchform})
                .then(function (response) {
                    Vuethis.giloading=false;
                    var data=response.data;
                    if(data.success==true)
                    {
                        Vuethis.graduatesinData=data.data.list;
                        Vuethis.giform.total=data.data.total;
                    }else{
                        Vuethis.$message.error(data.prompt);
                    }
                })
                .catch(function (error) {
                    Vuethis.giloading=false;
                    console.log(error);
                });
            },
            //军转干
            initsoldierData() {
                var Vuethis = this;
                this.sloading = true;
                this.$hrraxios.get(this.$api.plan.reportYuanSoldier, {params:this.searchform})
                .then(function(response) {
                    Vuethis.sloading = false;
                    var data = response.data;
                    if (data.success == true) {
                        Vuethis.soldierData = data.data;
                    } else {
                        Vuethis.$message.error(data.prompt);
                    }
                })
                .catch(function(error) {
                    Vuethis.sloading = false;
                    console.log(error);
                });
            },
            //京外调干
            initinbjData() {
                var Vuethis = this;
                this.iloading = true;
                this.$hrraxios.get(this.$api.plan.reportYuanInbjJob, {params:this.searchform})
                    .then(function(response) {
                        Vuethis.iloading = false;
                        var data = response.data;
                        if (data.success == true) {
                            Vuethis.inbjData = data.data;
                        } else {
                            Vuethis.$message.error(data.prompt);
                        }
                    })
                    .catch(function(error) {
                        Vuethis.iloading = false;
                        console.log(error);
                    });
            },
            //毕业生明细 reportYuangetDetailByPlanId
            initReportGraduatesDetailData() {
                var Vuethis = this;
                this.rdloading = true;
                this.searchform.pageNum=this.rdform.pageNum;
                this.searchform.pageSize=this.rdform.pageSize;
                this.$hrraxios.get(this.$api.plan.reportYuangetDetailByPlanId, {params:this.searchform})
                    .then(function(response) {
                        Vuethis.rdloading = false;
                        var data = response.data;
                        if (data.success == true) {
                            Vuethis.ReportGraduatesDetailData = data.data.list;
                            Vuethis.rdform.total=data.data.total;
                        } else {
                            Vuethis.$message.error(data.prompt);
                        }
                    })
                    .catch(function(error) {
                        Vuethis.rdloading = false;
                        console.log(error);
                    });
            },
            //毕业生情况统计 reportYuangetByPlanId
            initReportGraduatesData() {
                var Vuethis = this;
                this.rloading = true;
                this.$hrraxios.get(this.$api.plan.reportYuangetByPlanId, {params:this.searchform})
                    .then(function(response) {
                        Vuethis.rloading = false;
                        var data = response.data;
                        if (data.success == true) {
                            Vuethis.ReportGraduatesData = data.data;
                        } else {
                            Vuethis.$message.error(data.prompt);
                        }
                    })
                    .catch(function(error) {
                        Vuethis.rloading = false;
                        console.log(error);
                    });
            },
            initData() {
                this.searchform.planId=this.planIdData[0].planId;
                this.initreportAllData();
                this.initgraduatesAllData();
                this.initOpenOutData();
                this.initOpenInData();
                this.initgraduatesOutData();
                this.initgraduatesInData();
                this.initsoldierData();
                this.initinbjData();
                this.initReportGraduatesDetailData();
                this.initReportGraduatesData();
            },
            initParamsData(){
                var Vthis=this;
                this.$common.getplanlist(this,"planIdData",this.initData);
                this.$hrraxios.get(Vthis.$api.plan.getinstituteList)
                .then((response)=>{
                    var data=response.data;
                    if(data.success==true){
                        Vthis.instituteIdData=data.data;
                    }else{
                        Vthis.$message.error("获取所数据初始化失败,请联系管理员");
                    }
                })
                .catch((error)=>{
                    console.log(error);
                })
            },
            showbutn(status){
                return status!=20 && status!=10;
            },
            //修改岗位状态
            changeStatus(postId,status,w){
                var PostStatus=(Vuethis,pid,s,w,mes)=>{
                    var Vthis=Vuethis;
                    var loading = Vthis.$loading({
                        lock: true,
                        text: '提交中...',
                        spinner: 'el-icon-loading',
                        background: 'rgba(0, 0, 0, 0.7)'
                    });
                    var PUrl="";
                    var from={};
                    from.postId=postId;
                    if(s==20){
                        PUrl=Vthis.$api.plan.postStatusPoss;
                    }
                    if(s==10){
                        PUrl=Vthis.$api.plan.postStatusAdjuest;
                        from.message=mes;
                    }
                    if(s==-10){
                        PUrl=Vthis.$api.plan.postStatusReject;
                        from.message=mes;
                    }
                    Vuethis.$hrraxios.post(PUrl,from)
                    .then((response)=>{
                        loading.close();
                        var data = response.data;
                        if (data.success == true) {
                            Vthis.$alert("状态修改成功！",{callback:action=>{
                                if(w=="o"){
                                    Vthis.initOpenData();
                                }else{
                                    Vthis.initgraduatesData();
                                }
                            }});
                        } else {
                            Vthis.$message.error(data.prompt);
                        }
                    })
                    .catch((error) => {
                        loading.close();
                    });

                };
                if(status==20){
                    this.$confirm("确定要通过么？",{type:"warning"})
                    .then(()=>{
                        PostStatus(this,postId,status,w);
                    })
                    .catch((error)=>{
                    })
                }else{
                    var message=(status==-10)?"不通过":"调整";
                    this.$prompt('请输入您 "'+message+'" 的建议', '提示', {
                      confirmButtonText: '确定',
                      cancelButtonText: '取消',
                    }).then(({ value }) => {
                        PostStatus(this,postId,status,w,value);
                    }).catch(() => {

                    });
                }
            },
        },
        created(){
            this.initParamsData();
        }
    }

</script>
